
import ElementUI from 'element-ui';
export default {
  install(Vue, options) {
    Vue.prototype.$message = function(msg, type) {
      ElementUI.Message.closeAll();
      ElementUI.Message({
        message: msg.message,
        duration: 8000,
        showClose: true,
        type: msg.type
      });
    };
    Vue.prototype.$message.error = function(msg) {
      ElementUI.Message.closeAll();
      ElementUI.Message({
        message: msg,
        duration: 10000,
        showClose: true,
        type: 'error'
      });
    };
    Vue.prototype.$message.warning = function(msg) {
      ElementUI.Message.closeAll();
      ElementUI.Message({
        message: msg,
        duration: 10000,
        showClose: true,
        type: 'warning'
      });
    };
    Vue.prototype.$message.success = function(msg) {
      ElementUI.Message.closeAll();
      console.log(msg)
      ElementUI.Message({
        message: msg,
        duration: 5000,
        showClose: true,
        type: 'success'
      });
    };
    Vue.prototype.$message.close = function() {
      return ElementUI.Message.close();
    };
    Vue.prototype.$message.closeAll = function() {
      return ElementUI.Message.closeAll();
    };
  }
};



// WEBPACK FOOTER //
// ./src/message.js